const errorCode = (error: unknown): string => {
  if (!error || typeof error !== 'object' || !('code' in error)) return '';
  return typeof error.code === 'string' ? error.code : '';
};

export const signupErrorMessage = (error: unknown): string => {
  const code = errorCode(error);

  if (
    code.includes('invalid-credential') ||
    code.includes('invalid-login-credentials') ||
    code.includes('wrong-password')
  ) {
    return 'An account already exists for this email, but the password does not match. Use the existing account password or reset it from the login page.';
  }
  if (code.includes('email-already-in-use')) {
    return 'An account already exists for this email. Use that account to accept the invitation.';
  }
  if (code.includes('weak-password')) {
    return 'Choose a stronger password with at least 8 characters.';
  }
  if (code.includes('invalid-email')) {
    return 'Enter a valid email address.';
  }
  if (code.includes('too-many-requests')) {
    return 'Too many attempts were made. Wait a few minutes and try again.';
  }
  if (code.includes('network-request-failed')) {
    return 'The signup request could not reach the server. Check your connection and try again.';
  }
  if (code.includes('functions/already-exists')) {
    return 'This invitation has already been accepted. Sign in with the account that accepted it.';
  }
  if (code.includes('functions/not-found')) {
    return 'This invitation is no longer available. Ask an administrator for a new invitation.';
  }
  if (code.includes('functions/permission-denied')) {
    return 'This invitation cannot be used with the current account. Use the email address that was invited.';
  }
  if (code.includes('functions/resource-exhausted')) {
    return 'This business has reached its account limit. Ask an administrator to review the subscription.';
  }

  return 'We could not complete signup. Check your invitation and account details, then try again.';
};
